// extracted by mini-css-extract-plugin
var _1 = "RichTextFormValue_root__06e92";
export { _1 as "root" }
